"use client";

import useTranslate from "@app/_hooks/useTranslate";
import useAddToCart from "@features/cart/hooks/useAddToCart";
import { useCart } from "@features/cart/hooks/useCart";
import { Button } from "@ui/button";
import { ComponentProps, type FormEvent, useState } from "react";

import { cn } from "@/lib/utils";
import { useMarket } from "@features/market/useMarket";
import type { CartProduct } from "../utils/toCartProduct";

type ProductAccessoriesAddProps = {
  product: CartProduct;
} & ComponentProps<"form">;

export default function ProductAccessoriesAdd({
  product,
  className,
  ...props
}: ProductAccessoriesAddProps) {
  const t = useTranslate();
  const market = useMarket();
  const { items } = useCart();
  const { mutateAsync: addToCart, isPending } = useAddToCart();
  const [added, setAdded] = useState(false);
  const inCart = items.some((cartItem) => cartItem.partNo === product.partNo);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (inCart || added) return;
    await addToCart([product]);
    setAdded(true);
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={cn("whitespace-nowrap", className)}
      {...props}
    >
      <input type="hidden" name="productKey" value={product.key} />
      <input type="hidden" name="market" value={market.countryCode} />
      <input type="hidden" name="quantity" value="1" />
      <Button
        type="submit"
        variant={inCart || added ? "default" : "outline"}
        disabled={isPending}
        className="h-auto px-3 py-1 text-sm whitespace-nowrap"
      >
        {inCart || added ? t("added") : t("add")}
      </Button>
    </form>
  );
}
